/* eslint-disable max-len */
/* eslint-disable no-return-assign */
import { useCallback, useLayoutEffect, useRef } from 'react';

import { debounce } from '@mui/material';

import { useDeepCompareEffect, useDeepCompareLayoutEffect } from './useDeepCompareEffect';

export const useDebouncedEffect = (effect, deps = [], wait = 150) => {
  const cleanUp = useRef();
  const effectRef = useRef();

  effectRef.current = useCallback(effect, deps);

  const lazyEffect = useCallback(
    debounce(() => (cleanUp.current = effectRef.current?.()), wait),
    [],
  );

  useLayoutEffect(lazyEffect, deps);
  useLayoutEffect(() => () => (cleanUp.current instanceof Function ? cleanUp.current() : undefined), []);
};

export const useDebouncedDeepCompareEffect = (effect, deps = [], wait = 150) => {
  const cleanUp = useRef();
  const effectRef = useRef();

  effectRef.current = useCallback(effect, deps);

  const lazyEffect = useCallback(
    debounce(() => (cleanUp.current = effectRef.current?.()), wait),
    [],
  );

  useDeepCompareEffect(lazyEffect, deps);
  useDeepCompareEffect(() => () => (cleanUp.current instanceof Function ? cleanUp.current() : undefined), []);
};

export const useDebouncedDeepCompareLayoutEffect = (effect, deps = [], wait = 150) => {
  const cleanUp = useRef();
  const effectRef = useRef();

  effectRef.current = useCallback(effect, deps);

  const lazyEffect = useCallback(
    debounce(() => (cleanUp.current = effectRef.current?.()), wait),
    [],
  );

  useDeepCompareLayoutEffect(lazyEffect, deps);
  useDeepCompareLayoutEffect(() => () => (cleanUp.current instanceof Function ? cleanUp.current() : undefined), []);
};
